import { httpPut, httpGetNoAuth } from '../../../../Util/http';
import { addAlert } from '../../../../MsgNotify/msgNotifyActions';


export const DAILY_REPORT_UPDATE_DESCRIPTION = 'DAILY_REPORT_UPDATE_DESCRIPTION'
export const dailyReportUpdateDesccription = (value, typeOf = "description") => (
    {
        type: DAILY_REPORT_UPDATE_DESCRIPTION,
        value,
        typeOf
    }
)



export function attemptSaveDescription(currentDailyReportId, getState, dispatch) {
    var _url = process.env.REACT_APP_webApiEndPoint + 'api/dailyreport/description/register'
    let description = getState().dailyReportDescriptionReducer.description;
    let englishDescription = getState().dailyReportDescriptionReducer.englishDescription;
    description = englishDescription ? description + "&:TRANSLATED:&" + englishDescription : description;
    return httpPut(_url, { id: currentDailyReportId, description: description })
        .catch(() => {
            dispatch(addAlert("Kunne ikke gemme beskrivelsen"))
            throw new Error("Kunne ikke gemme beskrivelsen")
        })
}


export const TRANSLATE_DESCRIPTION_TEXT_REQUEST = 'TRANSLATE_DESCRIPTION_TEXT_REQUEST'
export const tranlateTextRequest = () => (
    {
        type: TRANSLATE_DESCRIPTION_TEXT_REQUEST
    }
)

export const TRANSLATE_DESCRIPTION_TEXT_SUCCESS = 'TRANSLATE_DESCRIPTION_TEXT_SUCCESS'
export const tranlateTextSuccess = (value) => (
    {
        type: TRANSLATE_DESCRIPTION_TEXT_SUCCESS,
        value
    }
)

export const TRANSLATE_DESCRIPTION_TEXT_FAILURE = 'TRANSLATE_DESCRIPTION_TEXT_FAILURE'
export const tranlateTextFailure = () => (
    {
        type: TRANSLATE_DESCRIPTION_TEXT_FAILURE
    }
)


export function attemptTranslateText() {
    return (dispatch, getState) => {
        let description = getState().dailyReportDescriptionReducer.description;
        let _url = 'https://www.googleapis.com/language/translate/v2?key=' + process.env.REACT_APP_googleApiKey + '&source=da&target=en&format=text'
        let resultsplit = description.split("&").join("og").split(/\r?\n/);
        resultsplit.forEach((line) => {
            _url += '&q=' + line
        })
        return httpGetNoAuth(_url)
            .then((response) => {
                return response.json()
            })
            .then((result) => {
                //if concat the results
                let concatRes = "";
                result.data.translations.forEach((line, index) => {
                    concatRes += line.translatedText;
                    if (index !== result.data.translations.length - 1) {
                        concatRes += "\n"
                    }
                })
                dispatch(tranlateTextSuccess(concatRes));
            })
            .catch(() => {
                dispatch(addAlert("Kunne ikke gemme beskrivelsen"))
                throw new Error("Kunne ikke gemme beskrivelsen")
            })
    };
}





// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Description/actions.js